import { render } from "./Facts.vue?vue&type=template&id=73726b02"
import script from "./Facts.vue?vue&type=script&lang=js"
export * from "./Facts.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src218436265/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__